<div class="flex md:py-[23px] relative justify-center block sm:hidden">

  

  <!-- Círculo con número 1 usando CSS -->
  <div *ngIf="circleNumber != 0"

    class="top-2/4 md:left-1/2 md:top-[200px] transform -translate-y-1/2 md:-translate-x-1/2 md:translate-y-0 w-14 h-14 md:w-16 md:h-16 bg-[#596AFE] rounded-full flex items-center justify-center"
  >
    <span class="text-white font-inter text-xl md:text-2xl font-bold">{{
      circleNumber
    }}</span>
  </div>
</div>

<div class="flex md:py-[23px] relative justify-between items-center">
  <button class="px-5 hidden md:block" type="button" (click)="goBack()">
      <i class="text-black text-2xl md:text-3xl pi pi-arrow-left"></i>
    </button>
    
  <div class="svgLogo hidden sm:block absolute left-1/2 transform -translate-x-1/2" [innerHTML]="teuLogo"></div>
</div>
